export default __webpack_public_path__ + "static/logo-fc368e2bdd47e8ede3f77117eaf7042f.svg";